const useUserStore = (set) => ({
  user: null,
  ldUser: null,
  setUser: (user) => set({ user }),
  setLdUser: (ldUser) => set({ ldUser }),
});

export default useUserStore;
